var map = {
	"./fino.png": 8430,
	"./fino2.png": 9550,
	"./fino3.png": 7863,
	"./normal.png": 3901,
	"./normal2.png": 6363,
	"./normal3.png": 4818,
	"./normal4.png": 4797,
	"./sério.png": 2716,
	"./sério2.png": 7604,
	"./sério3.png": 5085,
	"./zoião.png": 2990,
	"./zoião2.png": 7598,
	"./zoião3.png": 743,
	"./zoião4.png": 4952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4321;